


export default function DotB(){
    return(
        <span className="mx-c6">.</span>
    )
}